import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { CancelMembership, type CancelMembershipMutation, type CancelMembershipMutationVariables } from './api.graphql';

export async function cancelMembership(id: string, { gql: { fetch } }: UtilityContext): Promise<void> {
	const { data } = await fetch<CancelMembershipMutation, CancelMembershipMutationVariables>({
		query: CancelMembership,
		variables: { input: { id } },
		path: '/payments/cancelSubscription',
		// to ensure this rate limited mutation is not batched
		batched: false,
		rejectOnError: true,
	});

	const { result } = data.cancelSubscription;

	if (result === 'UNAUTHORIZED') {
		throw new Error('Unauthorized');
	}

	if (result !== 'SUCCESS') {
		throw new Error('Failed to cancel membership');
	}
}
